import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=5cfdfedd&scoped=true&lang=pug"
import script from "./Slots.vue?vue&type=script&lang=ts"
export * from "./Slots.vue?vue&type=script&lang=ts"
import style0 from "./Slots.vue?vue&type=style&index=0&id=5cfdfedd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfdfedd",
  null
  
)

export default component.exports